export default "__VITE_ASSET__DbLmMhGO__"